<div class="modal-body">
  <div class="container-fluid">
    <div class="grid-col flex-auto">
      <legend class="usa-legend usa-legend--medium">TSP Interstate Scope</legend>
    </div>
  </div>
  <div class=" padding-bottom-1 grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <img src="assets/uswds/img/usa-icons/file_download.svg" alt="user_icon"> Right click on the report and select the appropriate options to export.
    </div>
  </div>
  <div class="grid-row">
    <ag-grid-angular
      style="width: 100%; height: 400px;"
      class="ag-theme-alpine"
      [gridOptions]="updateMessagesOptions"
      [rowData]="rowData"
      [overlayNoRowsTemplate]="overlayNoRowsTemplate"
      [columnDefs]="columnDefs"
      [suppressDragLeaveHidesColumns]="true"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="closeModal()">Close</button>
</div>
